import { render, staticRenderFns } from "./translation-preview-modal.vue?vue&type=template&id=af8a3dac"
import script from "./translation-preview-modal.vue?vue&type=script&lang=js"
export * from "./translation-preview-modal.vue?vue&type=script&lang=js"
import style0 from "./translation-preview-modal.vue?vue&type=style&index=0&id=af8a3dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports